import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles/globals.css";

/**
 * Punto de entrada de la SPA.
 *
 * Vite monta `<App />` en `#root`. El `StrictMode` se mantiene para ayudar a
 * detectar efectos/estado problemáticos en desarrollo (en producción no tiene
 * coste).
 */
createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
